export const API_BASE_URL = '/api/admin';
export const RESEND_BASE_URL = '/api/outbound/resend';
export const GLOBAL_EVENTS_BASE_URL = '/api/global/events';
export const CRICKET_MODEL_BASE_URL = '/api/cricket';
export const TT_MODEL_BASE_URL = '/api/tabletennis';
// export const API_BASE_URL = 'http://localhost:8084/api/admin';
// export const RESEND_BASE_URL = 'http://localhost:8084/api/outbound/resend';
// export const GLOBAL_EVENTS_BASE_URL = 'http://localhost:8084/api/global/events';
// export const CRICKET_MODEL_BASE_URL = 'http://localhost:8084/api/cricket';

export const ENDPOINTS = {
    EVENTS: '/events',
    MARKETS: (eventId: number) => `/events/${eventId}/markets`,
    MARKETS_BASE: '/markets',
    MARKETS_BY_EVENT: (eventId: number) => `/markets/event/${eventId}`,
    MARKET_CONTROLS: '/markets/controls'
};
